import { createGetDataReducer } from "./CommonReducer";
import { SERVICELIST  ,  SERVICEADD , SERVICECATEGORYLIST , SERVICEDETAILS ,SERVICESTATUS} from "../../Constants/ServiceConstants";

export const ServiceGetReducer = createGetDataReducer( SERVICELIST );
export const ServiceCategoryReducer = createGetDataReducer( SERVICECATEGORYLIST );
export const ServiceDetailsReducer = createGetDataReducer( SERVICEDETAILS );
export const ServiceStatusReducer = createGetDataReducer( SERVICESTATUS );





